import React from 'react';
import { User } from '../../../../../entities/User';
import { ScorecardProsCons } from '../../../Scorecards/ScorecardPage/ScorecardBody/ScorecardProsCons';
import { ScorecardCategories } from './ScorecardCategories';
import styles from './styles.module.scss';
import { HorizontalDivider } from '../../../../../components/HorizontallDivider';
import { ScorecardLabel } from './ScorecardLabel';
import { InterviewStageScorecard } from '../../../../../entities/applicant_tracking/InterviewStage';

interface PropTypes {
  user: User;
  scorecard: InterviewStageScorecard;
}

export function ScorecardBody(props: PropTypes) {
  return (
    <>
      <ScorecardCategories user={props.user} scorecard={props.scorecard} />
      <HorizontalDivider classNames='mt-4' />
      <ScorecardProsCons
        title={
          <ScorecardLabel
            classNames='mb-2h'
            title='Pros'
            label='Open Text Area'
          />
        }
        label="Insert candidate's strengths"
        disabled={true}
        className={styles['pros-cons-input']}
      />
      <ScorecardProsCons
        title={
          <ScorecardLabel
            classNames='mb-2h'
            title='Cons'
            label='Open Text Area'
          />
        }
        label="Insert candidate's weaknesses"
        disabled={true}
        className={styles['pros-cons-input']}
      />
    </>
  );
}
